import React, { useContext, useRef } from 'react'

import { NavbarStoreContext } from '../../contexts'
import NavbarStore from '../../stores/NavbarStore/NavbarStore'

export const useNavbarStore = (): NavbarStore => {
   const navbarStore = useContext(NavbarStoreContext)
   if (!navbarStore) {
      throw new Error('Expected to be wrapped in Navbar Store Provider')
   }

   return navbarStore
}

interface Props {
   children: React.ReactElement
}

export const NavbarStoreProvider = (props: Props): React.ReactElement => {
   const navbarStore = useRef(new NavbarStore())

   return (
      <NavbarStoreContext.Provider value={navbarStore.current}>
         {props.children}
      </NavbarStoreContext.Provider>
   )
}
